export enum InlineCommentSubscriptionEvents {
	InlineCommentCreated = 'inlineCommentCreated',
	RendererInlineCommentCreated = 'rendererInlineCommentCreated',
	EditorInlineCommentCreated = 'editorInlineCommentCreated',
	InlineCommentDeleted = 'inlineCommentDeleted',
	InlineCommentResolved = 'inlineCommentResolved',
	InlineCommentUnresolved = 'inlineCommentUnresolved',
	InlineCommentUpdated = 'inlineCommentUpdated',
	InlineCommentReattached = 'inlineCommentReattached',
}

export enum PageSubscriptionEvents {
	PageUpdated = 'pageUpdated',
}
